// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dialog-add-gearset {
  border: none;
  box-sizing: border-box;
  position: fixed;
  /* height: 20vh;
    width: 45vw; */
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 8px rgba(124, 123, 123, 0.2);
  align-content: center;
}

#dialog-add-gearset-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 2fr 2fr 1fr;
  align-items: center;
  justify-items: center;
}

.dialog-heading {
  display: flex;
  justify-content: space-between;
  gap: 1%;
  padding: 1%;
}


.dialog-heading-text {
  color: var(--color-darkest);
}

.dialog-heading-text-alert {
  color: var(--color-accent);
}

.dialog-buttons {
  display: flex;
  gap: 1%;
  padding: 1%;
}

.dialog-buttons > button {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/dialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf;kBACgB;EAChB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,WAAW;AACb;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,WAAW;AACb;;AAEA;EACE,OAAO;AACT","sourcesContent":["#dialog-add-gearset {\n  border: none;\n  box-sizing: border-box;\n  position: fixed;\n  /* height: 20vh;\n    width: 45vw; */\n  top: 25%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 4px 8px rgba(124, 123, 123, 0.2);\n  align-content: center;\n}\n\n#dialog-add-gearset-container {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 2fr 2fr 1fr;\n  align-items: center;\n  justify-items: center;\n}\n\n.dialog-heading {\n  display: flex;\n  justify-content: space-between;\n  gap: 1%;\n  padding: 1%;\n}\n\n\n.dialog-heading-text {\n  color: var(--color-darkest);\n}\n\n.dialog-heading-text-alert {\n  color: var(--color-accent);\n}\n\n.dialog-buttons {\n  display: flex;\n  gap: 1%;\n  padding: 1%;\n}\n\n.dialog-buttons > button {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
